import { createContentHook } from './createContentHook';
import type { SalesAndResourcesResourceLibraryContent } from '../types/SalesAndResourcesResourceLibraryContent';

export const useSalesAndResourcesResourceLibraryContent =
    createContentHook<SalesAndResourcesResourceLibraryContent>(
        '/SalesAndResources/ResourceLibrary'
    );
